import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { useHomeGreeter } from '../hooks/useHomeGreeter';

const HomeGreeter = () => {
  const { greeting, subtitle } = useHomeGreeter();

  return (
    <Stack sx={{ textAlign: 'center' }} spacing={0.5} useFlexGap>
      <Typography variant="h2" color="text.primary">
        {greeting}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {subtitle}
      </Typography>
    </Stack>
  );
};

export default HomeGreeter;
